import { render } from "./IconTelegram.vue?vue&type=template&id=637f2a4c"
import script from "./IconTelegram.vue?vue&type=script&lang=js"
export * from "./IconTelegram.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__